import React, { useState } from "react";
import FormControl from "@mui/material/FormControl";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import DatePicker from "../../../../../library/custom/datePicker/DatePicker";
import TImePicker from "../../../../../library/custom/timePicker/TImePicker";
import { getFormatedDate } from "../../../../../utils/helper";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import Card from "../../../../../library/custom/card/Card";
import { Grid } from "@mui/material";
import SelectMenu from "../../../../../library/custom/selectMenu/SelectMenu";
import RadioGroup from "@mui/material/RadioGroup";
import RadioButton from "../../../../../library/custom/radioButton/RadioButton";
import TextEditor from "../../../../../library/custom/textEditor/TextEditor";
import { NumberField } from "../../../../../library/custom/numberField/numberField";
import Checkbox from "../../../../../library/checkbox/checkbox";
import { handleMinsonChangeRainfall } from "../../../../../utils/helper";
import ViewPastRainFall from "./viewPastRainFainfall";
const SwCommonForm = ({
  formValue,
  setFormValue,
  getInTyFeByInTyList,
  isProjectName,
  isCustomerName,
  isProjectNo,
  isPrimaryInspector,
  isDateofInspection,
  isTimeofInspection,
  isWeatherAtTimeofInspection,
  isSoilTypeId,
  isStageOfConstruction,
  isSampleTaken,
  isPrimaryPermitteeName,
  isCurrentApproximateDisturbedAcreage,
  isNPDESTrackingNumber,
  getSwReference,
  listPermitte,
  mapId,
  inspectionHeaderDetails,
  constructionActivityId,
  handleConstructionActivitySetChange,
  isConstructionActivityId,
  projectStatus,
  setProjectStatus,
  alsoSubmitRoutineInspection,
  handleChangeDefault,
  inspectionTypeId,
  characterLimit,
  isRainFallError,
  isDirectIns,
  editMode,
  frequencyValue,
  handleFrequencyChange,
  frequency,
  frequencyInDays,
  dateRangeHandler,
  dateRangeError,
  errorFrequencyInDays,
  frequencyValueError,
  disabledCheck,
  weather,
  swRainFallDataModalData,
  isReportId,
  isProjectStatus,
  userInfo,
  isRainfallChecked,
  isSiteAssessment,
  isTnpeNumber,
  isCpescNumber,
}) => {
  const date = new Date();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const time = `${hours}:${formattedMinutes}`;

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const handleClose = () => setOpen(false);

  const pastRainFallHandle = () => {
    setOpen(true);
  };
  return (
    <>
      {getInTyFeByInTyList
        ?.filter((field) => field.isSelected)
        ?.sort((a, b) => a.sequenceNumber - b.sequenceNumber)
        ?.map((field) => {
          if (field?.key === 1 && field.isSelected && mapId) {
            return (
              <Grid item md={6} xs={12} key={field.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Project Name"}
                    value={formValue?.projectName}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        projectName: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isProjectName && !formValue?.projectName && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 9 && mapId) {
            return (
              <Grid item md={6} xs={12} key={field.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Client"}
                    value={formValue?.customerName}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        customerName: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isCustomerName && !formValue?.customerName && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 34 && mapId) {
            return (
              <Grid item md={6} xs={12}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Inspection Name"}
                    value={formValue?.questionSetName}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 8 && mapId) {
            return (
              <Grid item md={6} xs={12} key={field.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Report ID"}
                    value={formValue?.reportId}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        reportId: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isReportId && !formValue?.reportId && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 12 && mapId) {
            return (
              <>
                <Grid item md={6} xs={12} key={field.key}>
                  <FormControl fullWidth>
                    <FormLabels label="Inspection Type" isRequired={true} />
                    <SelectMenu
                      placeholder="Please Select"
                      listData={getSwReference?.insTypeMstList ?? []}
                      value={inspectionTypeId ? inspectionTypeId : null}
                      disabled={true}
                    />
                  </FormControl>

                  {isCustomerName && !formValue?.inspectionType && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
                  {(editMode
                    ? !isDirectIns && parseInt(inspectionTypeId) === 2
                    : parseInt(inspectionTypeId) === 2) && (
                      <div className="alsoRoutine">
                        <Checkbox
                          checked={alsoSubmitRoutineInspection}
                          onChange={() => handleChangeDefault()}
                          label={"Also a routine Inspection"}
                        />
                      </div>
                    )}
                </Grid>

                {(inspectionTypeId === 1 ||
                  inspectionTypeId === 3 ||
                  alsoSubmitRoutineInspection) && (
                    <Grid lg={6} xs={12} sm={6} md={6} item>
                      <FormControl fullWidth>
                        <FormLabels label="Frequency" isRequired={true} />
                        <SelectMenu
                          placeholder="Please Select"
                          listData={frequency ?? []}
                          value={frequencyValue ? frequencyValue : null}
                          onchangehandler={(e) => handleFrequencyChange(e)}
                          // disabled={true}
                          // isError={isFrequency}
                          // errorMsg={isFrequency ? "Frequency is required" : ""}
                          disabled={disabledCheck()}
                        />
                      </FormControl>
                      {frequencyValueError && !frequencyValue && (
                        <p className="error">Frequency is required</p>
                      )}
                    </Grid>
                  )}
                {parseInt(frequencyValue) === 7 && (
                  <Grid item lg={6} xs={12} sm={12} md={6}>
                    <FormControl fullWidth={true}>
                      <NumberField
                        // disabled={true}
                        isRequired={true}
                        type="text"
                        label={"Date Range"}
                        maxLength="3"
                        value={frequencyInDays}
                        placeholder={"Enter Frequency In Days..."}
                        onChange={(value) => dateRangeHandler(value)}
                      />
                    </FormControl>
                    {dateRangeError && (
                      <p className="error">Number should be between 1 to 365</p>
                    )}
                    {errorFrequencyInDays && (
                      <p className="error">Please add frequencyInDays </p>
                    )}
                  </Grid>
                )}
              </>
            );
          } else if (field?.key === 2) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Project Number"}
                    value={formValue?.projectNo}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        projectNo: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isProjectNo && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 10) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Date of Inspection"}
                  isRequired={field.isMandatory}
                />
                <DatePicker
                  onChangeHandler={(e) =>
                    setFormValue({ ...formValue, dateofInspection: e })
                  }
                  value={
                    formValue?.dateofInspection
                      ? formValue?.dateofInspection
                      : getFormatedDate(date)
                  }
                  maxDateEnable={false}
                  isError={isDateofInspection}
                  errorMsg={
                    isDateofInspection ? "Please enter this required field" : ""
                  }
                />
                {/* {isDateofInspection && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )} */}
              </Grid>
            );
          } else if (field?.key === 3) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label={"Time of Inspection"}
                    isRequired={field.isMandatory}
                  />
                  <TImePicker
                    disabled={false}
                    value={
                      formValue.timeofInspection
                        ? formValue.timeofInspection
                        : time
                    }
                    onChangeTimeHandler={(e) =>
                      setFormValue({
                        ...formValue,
                        timeofInspection: e.target.value,
                      })
                    }
                  />
                </FormControl>
                {isTimeofInspection && !formValue.timeofInspection && (
                  <div className="error">
                    Please select this required field.
                  </div>
                )}
              </Grid>
            );
          } else if (field?.key === 13) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Name of Inspector"}
                    value={formValue?.primaryInspector}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        primaryInspector: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isPrimaryInspector && !formValue?.primaryInspector && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 21) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Inspector's phone number"}
                    value={formValue?.phoneNumber}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 36) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label={"Inspector's Email"}
                    value={formValue?.email}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 4) {
            return (
              <Grid item md={12} xs={12} key={field?.key}>
                <FormLabels
                  label="Weather at Time of Inspection"
                  isRequired={field.isMandatory}
                />
                <Card
                  staticCardData={true}
                  cardData={weather ?? []}
                  selectedVehicleAccident={formValue.WeatherAtTimeofInspection}
                  cardClickHandler={(val) =>
                    setFormValue({
                      ...formValue,
                      WeatherAtTimeofInspection: val,
                    })
                  }
                />
                {isWeatherAtTimeofInspection &&
                  !formValue.WeatherAtTimeofInspection.value && (
                    <div className="error">
                      Please select this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 17) {
            return (
              <Grid item md={12} xs={12} key={field?.key}>
                <FormLabels
                  label="Soil Condition"
                  isRequired={field.isMandatory}
                />
                <Card
                  staticCardData={true}
                  cardData={getSwReference?.soilList ?? []}
                  selectedVehicleAccident={formValue.soilTypeId}
                  cardClickHandler={(val) =>
                    setFormValue({
                      ...formValue,
                      soilTypeId: val,
                    })
                  }
                />
                {isSoilTypeId && !formValue.soilTypeId.value && (
                  <div className="error">
                    Please select this required field.
                  </div>
                )}
              </Grid>
            );
          } else if (field?.key === 14) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label="Stage of Construction"
                    isRequired={field.isMandatory}
                  />
                  <SelectMenu
                    placeholder="Please Select"
                    listData={getSwReference?.constructionStageList ?? []}
                    value={
                      formValue?.constructionStageId
                        ? formValue?.constructionStageId
                        : null
                    }
                    onchangehandler={(e) =>
                      setFormValue({
                        ...formValue,
                        constructionStageId: e.target.value,
                      })
                    }
                  // isError={isStageOfConstruction}
                  // errorMsg={
                  //   isStageOfConstruction &&
                  //   formValue?.constructionStageId === 0
                  //     ? "Please enter this required field."
                  //     : ""
                  // }
                  />
                </FormControl>
                {isStageOfConstruction && !formValue.constructionStageId && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 6) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Sample Taken"}
                  isRequired={field.isMandatory}
                />
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  className="radioGroup"
                >
                  <RadioButton
                    checked={formValue.sampleTaken == "3"}
                    value="3"
                    label="Yes"
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        sampleTaken: e.target.value,
                      })
                    }
                  ></RadioButton>
                  <RadioButton
                    checked={formValue.sampleTaken == "1"}
                    value="1"
                    label="No"
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        sampleTaken: e.target.value,
                      })
                    }
                  ></RadioButton>
                </RadioGroup>
                {isSampleTaken && !formValue.sampleTaken && (
                  <div className="error">
                    Please select this required field.
                  </div>
                )}
              </Grid>
            );
          } else if (field?.key === 5) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth={true}
                    // disabled={true}
                    type="text"
                    label={"Rainfall Amount (inches)"}
                    value={formValue?.rainfall}
                    onChange={(event, value) =>
                      handleMinsonChangeRainfall(event, setFormValue, formValue)
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                <div className="viewPast7RainFall" onClick={pastRainFallHandle}>
                  View past 7 days rainfall data
                </div>
                <ViewPastRainFall
                  open={open}
                  modalData={modalData}
                  handleClose={handleClose}
                  swRainFallDataModalData={swRainFallDataModalData}
                />
                {isRainFallError && !formValue?.rainfall && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 16) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth className="approximate">
                  <InputField
                    fullWidth={true}
                    disabled={false}
                    type="text"
                    label={"Current Approximate Disturbed Acreage"}
                    value={formValue?.disturbedAcreage}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        disturbedAcreage: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isCurrentApproximateDisturbedAcreage &&
                  !formValue?.disturbedAcreage && (
                    <div className="error">
                      Please enter this required field.
                    </div>
                  )}
              </Grid>
            );
          } else if (field?.key === 19) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Site Name"}
                    value={
                      formValue?.isStandalone === false
                        ? inspectionHeaderDetails?.siteName
                        : "N/A"
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 18) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label="Construction Activity"
                    isRequired={field.isMandatory}
                  />
                  <SelectMenu
                    placeholder="Please Select"
                    listData={getSwReference?.constructionActivity ?? []}
                    value={constructionActivityId || null}
                    onchangehandler={(e) =>
                      handleConstructionActivitySetChange(e)
                    }
                    isError={isConstructionActivityId}
                    errorMsg={
                      isConstructionActivityId
                        ? "Please enter this required field."
                        : ""
                    }
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 20) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Division"}
                    value={inspectionHeaderDetails?.divisionName}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 22) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Company performing inspection"}
                    value={formValue?.companyPerformingInspection}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 23) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <FormLabels
                    label="Project Status"
                    isRequired={field.isMandatory}
                  />
                  <RadioGroup
                    row
                    name="row-radio-buttons-group"
                    className="radioGroup"
                  >
                    <RadioButton
                      checked={projectStatus === "1"}
                      value="1"
                      label="Active"
                      onChange={(e) => setProjectStatus(e.target.value)}
                    />
                    <RadioButton
                      checked={projectStatus === "2"}
                      value="2"
                      label="Inactive"
                      onChange={(e) => setProjectStatus(e.target.value)}
                    />
                  </RadioGroup>
                </FormControl>
                {isProjectStatus && (
                  <p className="error">Please enter this required field.</p>
                )}
              </Grid>
            );
          } else if (field?.key === 24) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"State"}
                    value={inspectionHeaderDetails?.stateName}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 25) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Address"}
                    value={inspectionHeaderDetails?.address ?? "N/A"}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 27) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Job Title"}
                    value={formValue.jobTitle}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 26) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    disabled
                    type="text"
                    label={"Certification Number"}
                    value={formValue?.certificationNumber}
                    isRequired={field.isMandatory}
                  />
                </FormControl>
              </Grid>
            );
          } else if (field?.key === 39) {
            return (
              <Grid item md={12} xs={12} className="companyPerforming">
                <div className="companyPerformingTitle">
                  Company Performing Inspection Address
                </div>
                <div className="companyPerforming">
                  Address Line 1:{" "}
                  <span> {formValue.clientAddress1 || "N/A"}</span>
                </div>
                <div className="companyPerforming">
                  Address Line 2:{" "}
                  <span> {formValue.clientAddress2 || "N/A"}</span>
                </div>
                <div className="companyPerforming columnBox">
                  <div className="column">
                    State: <span> {formValue.clientState || "N/A"}</span>
                  </div>
                  <div className="column">
                    City: <span>{formValue.clientCity || "N/A"}</span>
                  </div>
                </div>
                <div className="companyPerforming">
                  Zip Code: <span>{formValue.clientZipCode || "N/A"}</span>
                </div>
              </Grid>
            );
          }
          return null;
        })}

      {(() => {
        const permitFields = [7, 15, 28, 37, 38];
        const selectedPermitFields = getInTyFeByInTyList?.filter(
          (field) => permitFields.includes(field.key) && field.isSelected
        );
        if (selectedPermitFields?.length > 0) {
          return (
            <Grid item md={12} xs={12} className="northCarolinaOverride">
              <div className="commonTableBoxNorth">
                <div className="commonTableBoxNorthTitle">Permit Details</div>
                <div className="tableWrapper">
                  <table>
                    <thead>
                      <tr className="tableHead">
                        {selectedPermitFields.find((f) => f.key === 7) && (
                          <th>Permit Number</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 15) && (
                          <th>Permit Enforcement</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 28) && (
                          <th>Permittee Address</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 37) && (
                          <th>Permit Approval Date</th>
                        )}
                        {selectedPermitFields.find((f) => f.key === 38) && (
                          <th>Permit Expiration Date</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {listPermitte?.length > 0 ? (
                        listPermitte.map((x, index) => (
                          <tr className="tableBody" key={index}>
                            {selectedPermitFields.map((field) => {
                              let value = "N/A";
                              switch (field.key) {
                                case 7:
                                  value = x.permitteOrNPDESNumber || "N/A";
                                  break;
                                case 15:
                                  value = x.permitteEnforcement || "N/A";
                                  break;
                                case 28:
                                  value = x.permitteAddress || "N/A";
                                  break;
                                case 37:
                                  value = x.permitteApprovalDate || "N/A";
                                  break;
                                case 38:
                                  value = x.permitteExpirationDate || "N/A";
                                  break;
                                default:
                                  value = "N/A";
                              }
                              return <td key={field.key}>{value} </td>;
                            })}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          {selectedPermitFields.map((field, index) => (
                            <td key={index}>N/A</td>
                          ))}
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Grid>
          );
        }
        return null;
      })()}

      {getInTyFeByInTyList
        ?.filter((field) => field.isSelected)
        ?.sort((a, b) => a.sequenceNumber - b.sequenceNumber)
        ?.map((field) => {
          if (field?.key === 29) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Has rainfall been checked/documented daily"}
                  isRequired={field.isMandatory}
                />
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  className="radioGroup"
                >
                  <RadioButton
                    checked={formValue.isRainfallChecked == "1"}
                    value="1"
                    label="Yes"
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        isRainfallChecked: e.target.value,
                      })
                    }
                  ></RadioButton>
                  <RadioButton
                    checked={formValue.isRainfallChecked == "2"}
                    value="2"
                    label="No"
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        isRainfallChecked: e.target.value,
                      })
                    }
                  ></RadioButton>
                </RadioGroup>
                {isRainfallChecked && !formValue.isRainfallChecked && (
                  <div className="error">
                    Please select this required field.
                  </div>
                )}
              </Grid>
            );
          } else if (field?.key === 30) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormLabels
                  label={"Site Assessment"}
                  isRequired={field.isMandatory}
                />
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  className="radioGroup"
                >
                  <RadioButton
                    checked={formValue.siteAssessment == 1}
                    value="1"
                    label="Yes"
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        siteAssessment: e.target.value,
                      })
                    }
                  ></RadioButton>
                  <RadioButton
                    checked={parseInt(formValue.siteAssessment) == 2}
                    value="2"
                    label="No"
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        siteAssessment: e.target.value,
                      })
                    }
                  ></RadioButton>
                </RadioGroup>
                {isSiteAssessment && !formValue.siteAssessment && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 31) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    type="text"
                    label={"Assessor's TN PE registration number"}
                    value={formValue?.tnpeNumber}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        tnpeNumber: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isTnpeNumber && !formValue.tnpeNumber && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          } else if (field?.key === 32) {
            return (
              <Grid item md={6} xs={12} key={field?.key}>
                <FormControl fullWidth>
                  <InputField
                    fullWidth
                    type="text"
                    label={"Assessor's TNEPSC Level II / CPESC number"}
                    value={formValue?.cpescNumber}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        cpescNumber: e.target.value,
                      })
                    }
                    isRequired={field.isMandatory}
                  />
                </FormControl>
                {isCpescNumber && !formValue.cpescNumber && (
                  <div className="error">Please enter this required field.</div>
                )}
              </Grid>
            );
          }
          return null;
        })}

      <Grid item md={12} xs={12}>
        <FormLabels label="General Comments" />

        <TextEditor
          value={formValue?.generalComments}
          placeholder={"Enter Here..."}
          onChange={(e) => setFormValue((prevFormValue) => ({ ...prevFormValue, generalComments: e }))}
        />
        {!characterLimit && formValue?.generalComments?.length > 2000 && (
          <p className="error">Character limit exceeded.</p>
        )}
        {characterLimit && (
          <p className="error">Character limit exceeded 2000.</p>
        )}
      </Grid>

      {/* </Grid>
      </Grid> */}
    </>
  );
};

export default SwCommonForm;
